import React from 'react';
import { Helmet } from "react-helmet";

// Interface for component props
interface MainHelmetProps {
    props?: unknown;
}

export default function MainHelmet({props}: MainHelmetProps) {

	return (
		<Helmet>
			<meta name="viewport" content="width=device-width, initial-scale=1.0"/>
			<meta charSet="utf-8"/>
			<meta http-equiv="X-UA-Compatible" content="IE=edge"/>

			<link rel="icon" href="/s/img/WTSLogo_16x16.png" sizes="16x16" type="image/png" />
			<link rel="icon" href="/s/img/WTSLogo_32x32.png" sizes="32x32" type="image/png" />
			<link rel="icon" href="/s/img/WTSLogo_48x48.png" sizes="48x48" type="image/png" />
			<link rel="icon" href="/s/img/WTSLogo_96x96.png" sizes="96x96" type="image/png" />
			<link rel="icon" href="/s/img/WTSLogo_128x128.png" sizes="128x128" type="image/png" />
			<link rel="icon" href="/s/img/WTSLogo_180x180.png" sizes="180x180" type="image/png" />
			<link rel="preload" href="/s/fonts/materialdesignicons-webfont.woff2?v=1.4.57" as="font" type="font/woff2" crossOrigin="" />
			<link rel="preload" href="/s/fonts/fontawesome-webfont.woff2?v=4.7.0" as="font" type="font/woff2" crossOrigin="" />
			<meta property="og:site_name" content="Web Technology Survey" />
			<meta property="og:type" content="website" />
			<meta property="og:image" content="https://webtechsurvey.com/s/img/WTSLogo_180x180.png" />
			<link rel="preconnect" href="https://www.gstatic.com/" />
			<link rel="preconnect" href="https://maps.googleapis.com/" />
		</Helmet>
	)
} 

